import { render, staticRenderFns } from "./WithdrawTab.vue?vue&type=template&id=6ff35d42&scoped=true"
import script from "./WithdrawTab.vue?vue&type=script&lang=js"
export * from "./WithdrawTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff35d42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff35d42')) {
      api.createRecord('6ff35d42', component.options)
    } else {
      api.reload('6ff35d42', component.options)
    }
    module.hot.accept("./WithdrawTab.vue?vue&type=template&id=6ff35d42&scoped=true", function () {
      api.rerender('6ff35d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/WithdrawTab.vue"
export default component.exports